export default {
    methods: {
        numberFormat: function (number) {
            return new Intl.NumberFormat().format(number)
        },

        nl2br: function (str, is_xhtml = false) {
            return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + '<br />' + '$2');
        },

        processError: function (error) {
            if (typeof error == 'string') {
                this.error = 'Неизвестная ошибка, попробуйте позже';
            } else if (error && !error.response) {
                console.log('Component error');
            } else if (error.response.data.errors) {
                // Backend form request validation
                this.errors = error.response.data.errors;
            } else if (error.response.data.message) {
                // Backend manual validation
                this.error = error.response.data.message;
            } else {
                this.error = 'Неизвестная ошибка, попробуйте позже';
            }
        },

        notifySuccess: function (message) {
            this.success(message);
        },

        notEmptyObject: function (object) {
            return typeof object === 'object' && object !== null && Object.keys(object).length
        },

        substrEllipsis: function (str = '', length = 100) {
            return str.length > length ? str.substring(0, length) + "..." : str;
        },
        runDownloading: function (res, file_title) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file_title);
            document.body.appendChild(link);
            link.click();
        },

    }
}
